import ConstituentExportFieldName from '@/constants/constituents/ConstituentExportFieldName';
import CsvExportBasicProfileFields from './CsvExportBasicProfileFields';

const CsvExportApiFields: ConstituentExportFieldName[] = [
  ...CsvExportBasicProfileFields.map(({ fieldName }) => fieldName),
  ConstituentExportFieldName.CUSTOM_FIELDS,
];

export default CsvExportApiFields;
